(() => {
  const rootSelector = '[data-sd-ui-pricing]';

  const initializeRealFreight = (root) => {
    const productInfo = root.closest('.product__info-container');
    const select = productInfo?.querySelector('[data-sd-variant-price-select]');
    const submit = productInfo?.querySelector('.product-form__submit');
    if (!productInfo || !select) return;

    const all = Array.from(root.querySelectorAll('[data-sd-reference-row]'));
    const byId = new Map(all.map((r) => [String(r.dataset.variantId), r]));
    const byCombination = new Map();
    all.forEach((row) => byCombination.set(
      `${row.dataset.sdPackKey}:${row.dataset.sdFreightKey}`, row
    ));
    // Purchase only genuine Shopify variants with their actual variant prices.
    // Disable non-existent combinations and use Shopify variant prices only.
    if (!byCombination.has('single:delivered') || !byCombination.has('single:own')) {
      console.warn('SeoulDepot: shipping options need review for this product.');
    }
    const packs = Array.from(root.querySelectorAll('[data-sd-pack-variant]'));
    const freightButtons = Array.from(root.querySelectorAll('[data-sd-fulfillment]'));
    const packOf = (id) => byId.get(String(id))?.dataset.sdPackKey || 'single';
    const freightOf = (id) => byId.get(String(id))?.dataset.sdFreightKey || 'delivered';
    const getRow = (pack, mode) => byCombination.get(`${pack}:${mode}`);
    const getRowForId = (id) => byId.get(String(id));
    let pack = packOf(select.value);
    let mode = freightOf(select.value);

    productInfo.dataset.sdRealFreight = 'true';
    productInfo.dataset.sdUiEnhanced = 'true';

    const showSelection = () => {
      const choice = getRow(pack, mode);
      // Keep Shopify's private line item property in sync with the actual selected variant.
      // Disabled inputs are excluded from product form submission for Delivered variants.
      const freightProperty = productInfo.querySelector('[data-sd-freight-line-property]');
      if (freightProperty) freightProperty.disabled = choice?.dataset.sdFreightKey !== 'own';
      const delivered = getRow(pack, 'delivered');
      const own = getRow(pack, 'own');
      packs.forEach((button) => {
        const candidatePack = packOf(button.dataset.sdPackVariant);
        button.classList.toggle('is-selected', candidatePack === pack);
        const candidate = getRow(candidatePack, mode);
        const total = button.querySelector('[data-sd-pack-total]');
        const unit = button.querySelector('[data-sd-pack-unit]');
        if (total) total.textContent = candidate?.dataset.sdPriceTotal || 'Unavailable';
        if (unit) unit.textContent = candidate ? `${candidate.dataset.sdPriceUnit} / unit` : 'Unavailable';
        button.disabled = !candidate;
      });
      freightButtons.forEach((button) => {
        const active = button.dataset.sdFulfillment === (mode === 'own' ? 'own' : 'landed');
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-checked', String(active));
      });
      productInfo.dataset.sdOwnFreight = String(mode === 'own');
      // Own Freight is a priced Shopify variant, not a sourcing request for this product.
      const ownMessage = root.querySelector('[data-sd-own-message]');
      if (ownMessage) ownMessage.hidden = true;
      submit?.removeAttribute('aria-hidden');
      const ownUnit = root.querySelector('[data-sd-own-unit]');
      const ownTotal = root.querySelector('[data-sd-own-total]');
      const deliveredUnit = root.querySelector('[data-sd-landed-unit]');
      if (ownUnit) ownUnit.textContent = own?.dataset.sdPriceUnit || 'Unavailable';
      if (ownTotal) ownTotal.textContent = own ? `${own.dataset.sdPriceTotal} selected pack` : 'Unavailable';
      if (deliveredUnit) deliveredUnit.textContent = delivered?.dataset.sdPriceUnit || 'Unavailable';
      const referenceUnit = root.querySelector('[data-sd-reference-unit]');
      const breakdownOwn = root.querySelector('[data-sd-breakdown-own]');
      const breakdownDelivered = root.querySelector('[data-sd-breakdown-delivered]');
      if (referenceUnit) referenceUnit.textContent = own?.dataset.sdPriceUnit || 'Unavailable';
      if (breakdownOwn) breakdownOwn.textContent = own?.dataset.sdPriceUnit || 'Unavailable';
      if (breakdownDelivered) breakdownDelivered.textContent = delivered?.dataset.sdPriceUnit || 'Unavailable';

      const canBuy = Boolean(choice && Array.from(select.options).some(option => option.value === choice.dataset.variantId && !option.disabled));
      if (submit) {
        submit.disabled = !canBuy;
        submit.setAttribute('aria-disabled', String(!canBuy));
      }
    };

    const updateSelectedVariant = (newPack, newMode) => {
      const choice = getRow(newPack, newMode);
      if (!choice) return;
      const option = Array.from(select.options).find(option => option.value === choice.dataset.variantId);
      if (!option || option.disabled) return;
      pack = newPack;
      mode = newMode;
      select.value = choice.dataset.variantId;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      showSelection();
    };

    packs.forEach((button) => button.addEventListener('click', () => {
      updateSelectedVariant(packOf(button.dataset.sdPackVariant), mode);
    }));
    freightButtons.forEach((button) => button.addEventListener('click', () => {
      updateSelectedVariant(pack, button.dataset.sdFulfillment === 'own' ? 'own' : 'delivered');
    }));
    select.addEventListener('change', () => {
      const r = getRowForId(select.value);
      if (!r) return;
      pack = r.dataset.sdPackKey;
      mode = r.dataset.sdFreightKey;
      showSelection();
    });
    // Honor a preselected Own Freight variant in product URLs and previews.
    showSelection();
  };


  const initialize = (scope = document) => {
    scope.querySelectorAll(rootSelector).forEach((root) => {
      if (root.dataset.sdUiReady === 'true') return;
      root.dataset.sdUiReady = 'true';
      if (root.dataset.sdRealFreight === 'true') {
        initializeRealFreight(root);
        return;
      }

      const productInfo = root.closest('.product__info-container');
      const select = productInfo?.querySelector('[data-sd-variant-price-select]');
      const submit = productInfo?.querySelector('.product-form__submit');
      const ownAdd = root.querySelector('[data-sd-own-add]');
      const ownReview = root.querySelector('[data-sd-own-review]');
      const ownFallback = root.querySelector('.sd-ui-own-message__fallback');
      if (!productInfo || !select) return;

      productInfo.dataset.sdUiEnhanced = 'true';

      const refs = new Map();
      root.querySelectorAll('[data-sd-reference-row]').forEach((row) => refs.set(row.dataset.variantId, row));

      let fulfillmentMode = 'delivered';

      const selectedOwnFreightItem = () => {
        const id = select.value;
        const ref = refs.get(id);
        const packButton = root.querySelector(`[data-sd-pack-variant="${id}"]`);
        if (!ref || !packButton) return null;
        const packLabel = packButton.querySelector('span:first-child strong')?.textContent?.trim() || ref.dataset.variantTitle || 'Selected pack';
        const packUnits = Math.max(1, Number(ref.dataset.units || 1));
        const referenceUnitCents = Math.max(0, Number(ref.dataset.referenceCents || 0));
        const referenceSubtotalCents = Math.max(0, Number(ref.dataset.referenceTotalCents || 0));
        return {
          key: `${root.dataset.productHandle}::${id}`,
          handle: root.dataset.productHandle || '',
          productUrl: root.dataset.productUrl || '',
          title: root.dataset.productTitle || document.title,
          image: root.dataset.productImage || '',
          variantId: id,
          variantTitle: ref.dataset.variantTitle || '',
          sku: ref.dataset.sku || '',
          packLabel,
          packUnits,
          quantityUnits: packUnits,
          referenceUnitCents,
          referenceSubtotalCents
        };
      };

      const updateDisplayedPackPrices = () => {
        root.querySelectorAll('[data-sd-pack-variant]').forEach((button) => {
          const ref = refs.get(button.dataset.sdPackVariant);
          if (!ref) return;
          const total = button.querySelector('[data-sd-pack-total]');
          const unit = button.querySelector('[data-sd-pack-unit]');
          if (total) total.textContent = fulfillmentMode === 'own' ? (ref.dataset.referenceTotal || '—') : (ref.dataset.landedTotal || '—');
          if (unit) unit.textContent = `${fulfillmentMode === 'own' ? (ref.dataset.reference || '—') : (ref.dataset.landedUnit || '—')} / unit`;
        });
      };

      const updateVariant = () => {
        const id = select.value;
        const ref = refs.get(id);
        if (!ref) return;

        root.querySelectorAll('[data-sd-pack-variant]').forEach((button) => {
          button.classList.toggle('is-selected', button.dataset.sdPackVariant === id);
        });

        root.querySelector('[data-sd-reference-unit]').textContent = ref.dataset.reference || '—';
        root.querySelector('[data-sd-landed-unit]').textContent = ref.dataset.landedUnit || '—';
        root.querySelector('[data-sd-breakdown-reference]').textContent = ref.dataset.reference || '—';
        const shipping = root.querySelector('[data-sd-breakdown-shipping]');
        const customs = root.querySelector('[data-sd-breakdown-customs]');
        const tariff = root.querySelector('[data-sd-breakdown-tariff]');
        if (shipping) shipping.textContent = ref.dataset.shippingAllocation || '—';
        if (customs) customs.textContent = ref.dataset.customsAllocation || '—';
        if (tariff) tariff.textContent = ref.dataset.tariffAllocation || '—';
        root.querySelector('[data-sd-breakdown-total]').textContent = ref.dataset.landedUnit || '—';

        const ownUnit = root.querySelector('[data-sd-own-unit]');
        const ownTotal = root.querySelector('[data-sd-own-total]');
        if (ownUnit) ownUnit.textContent = ref.dataset.reference || '—';
        if (ownTotal) ownTotal.textContent = `${ref.dataset.referenceTotal || '—'} selected pack`;
        if (ownAdd) {
          const packButton = root.querySelector(`[data-sd-pack-variant="${id}"]`);
          const packLabel = packButton?.querySelector('span:first-child strong')?.textContent?.trim() || 'selected pack';
          ownAdd.textContent = 'Add to Custom Sourcing List';
          ownAdd.disabled = Number(ref.dataset.referenceTotalCents || 0) <= 0;
        }

        updateDisplayedPackPrices();
      };

      root.querySelectorAll('[data-sd-pack-variant]').forEach((button) => {
        button.addEventListener('click', () => {
          select.value = button.dataset.sdPackVariant;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          updateVariant();
        });
      });

      root.querySelectorAll('[data-sd-fulfillment]').forEach((button) => {
        button.addEventListener('click', () => {
          const mode = button.dataset.sdFulfillment;
          const own = mode === 'own';
          fulfillmentMode = own ? 'own' : 'delivered';
          root.querySelectorAll('[data-sd-fulfillment]').forEach((option) => {
            const selected = option === button;
            option.classList.toggle('is-selected', selected);
            option.setAttribute('aria-checked', String(selected));
          });
          productInfo.dataset.sdOwnFreight = String(own);
          const ownMessage = root.querySelector('[data-sd-own-message]');
          if (ownMessage) ownMessage.hidden = !own;
          if (submit) submit.setAttribute('aria-hidden', own ? 'true' : 'false');
          updateVariant();
        });
      });

      if (ownAdd) {
        ownAdd.addEventListener('click', () => {
          const item = selectedOwnFreightItem();
          if (!item || item.referenceSubtotalCents <= 0) {
            if (ownFallback) window.location.href = ownFallback.href;
            return;
          }
          if (window.SDCustomSourcingList && typeof window.SDCustomSourcingList.add === 'function') {
            window.SDCustomSourcingList.add(item);
          } else if (ownFallback) {
            window.location.href = ownFallback.href;
          }
        });
      }

      if (ownReview) {
        ownReview.addEventListener('click', () => {
          if (window.SDCustomSourcingList && typeof window.SDCustomSourcingList.open === 'function') {
            window.SDCustomSourcingList.open();
          } else if (ownFallback) {
            window.location.href = ownFallback.href;
          }
        });
      }

      select.addEventListener('change', updateVariant);
      updateVariant();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
